import { Component, OnInit } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { ValidateId } from "../id-validator";
import { PhoneNumberComponent } from '../phone-number/phone-number.component';
import { LeadService } from "../services/lead.service";
import { Lead } from "../interfaces/lead";
import { environment } from "../../environments/environment";

@Component({
	selector: 'app-user-details',
	templateUrl: './user-details.component.html',
	styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
	userDetails: FormGroup;
	prevQID: any;
	isAdvisor = this.questionnaireService.getIsAdvisor();
	private route$: Subscription;
	qID: any;
	currentStep;
	visibleQids;
	currentStepName;
	isMobilePhone: boolean;
	submitted;
	editQuestion;

	qFields = {
		1: [
			{ name: "firstName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
			{ name: "lastName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }
		],
		2: [{ name: "idNumber", validators: [Validators.required, ValidateId] }],
		3: [{ name: "phoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] }],
        4: [{ name: "email", validators: [Validators.pattern("^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,5})$")] }]
	};

	constructor(
		private fb: FormBuilder,
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private leadService: LeadService
	) { }

	ngOnInit() {
		this.questionnaireService.dataChangedEvent.subscribe(() => {
			this.userDetails.reset();
		});
		
		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;
			this.currentStepName = "user-details";
			

			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.clearPreviousQuestionValidators();
			} else {
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("user-details");
		this.userDetails = this.fb.group({
			firstName: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			lastName: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[1].answerValue,
			idNumber: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			phoneNumber: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue,
			email: this.questionnaireService.getQuestion(this.currentStep, "4").answer.fields[0].answerValue
		});
	}

	updateValidators(event) {
		this.setValidators();
	}

	validatePhone(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.includes("בחר")) {
				return {
					required: true
				};
			}
			if (this.isMobilePhone && control.value && control.value.length < 10) {//isMobilePhone not working
				return {
					minlength: true
				};
			} else if (!this.isMobilePhone && control.value && control.value.length < 9) {//isMobilePhone not working
				return {
					minlength: true
				};
			}
		};
	}

	setValidators() {
		// if (this.prevQID) {
		this.clearPreviousQuestionValidators();
		// }
		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.userDetails.controls[field.name].setValidators(field.validators);
			this.userDetails.controls[field.name].updateValueAndValidity();
		}
		this.submitted = false;
	}

	clearPreviousQuestionValidators() {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(this.qFields);

		for (let i = 0; i < keys.length; i++) {

			for (let j = 0; j < this.qFields[keys[i]].length; j++) {
				this.userDetails.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.userDetails.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	
//short lead after phone field only for outer cycle type, not from EXTERNAL URL

let cycleType = this.questionnaireService.getCycleType();

if(qID === "3" && cycleType === 'outer' && this.leadService.queryObjParams && Object.keys(this.leadService.queryObjParams).length === 0) { 

	//&& this.leadService.queryObjParams && this.leadService.queryObjParams.caID //short lead only from external URL: 

	let currentStep = this.questionnaireService.getActiveStep();

	let prefixLength = currentStep.questions[2].answer.fields[0].answerValue.length === 10 ? 3 : 2;



	

	//let abandonCampainCode = (cycleType === 'inner') ? '1097' : '1095';



	let lead: Lead = {

		campaign_code: '1095', //outer abandon campain code

		first_name: currentStep.questions[0].answer.fields[0].answerValue,

		last_name: currentStep.questions[0].answer.fields[1].answerValue,

		Id: currentStep.questions[1].answer.fields[0].answerValue,

		id_type: '1',

		phone_1_prefix: currentStep.questions[2].answer.fields[0].answerValue.substring(0, prefixLength),

		phone_1_number: currentStep.questions[2].answer.fields[0].answerValue.substring(prefixLength)

	  };

	  

	  this.leadService.resetGuid();

	  this.leadService.sendLead(lead,false,false).subscribe(

		data => {

		  console.log("send lead sucseed");

		});

	}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit():  value=", value, "valid=", valid);
		this.submitted = true;

		if (valid) {
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;
			q = this.qFields[submitQID];

			let values = q.map(r => {
				return value[r.name];
			});
			this.questionnaireService.sendGA(this.currentStep,this.qID, values);
			this.nextClick(submitQID, values);
		}
	}

	editQuestionChange(qid){
		this.qID = qid;
		this.setValidators();
	}
}



// WEBPACK FOOTER //
// ./src/app/user-details/user-details.component.ts